import { HttpClient } from "../HttpClient";
/**
 * * Get Cash Advances
 */

export const GetCashAdvances = async(id) => {
  try {
    const { data } = await HttpClient.get('api/instacash/cashadvances/searchcriteria', {
      params: {
        id
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
